import {Component, inject, Input} from '@angular/core';
import {InlineArrayItemService} from '../../../core/inline-array-item.service';
import {FieldParameters} from '../../../core/definitions/field-parameters';

@Component({
    selector: 'app-edit-field-inline-array-delete-button',
    templateUrl: './edit-field-inline-array-delete-button.component.html',
    styleUrls: ['./edit-field-inline-array-delete-button.component.scss'],
    standalone: false
})
export class EditFieldInlineArrayDeleteButtonComponent {
  // Injections
  private readonly inlineArrayItemSvc: InlineArrayItemService = inject(InlineArrayItemService);

  @Input() fieldParameters: FieldParameters;
  @Input() arrayIndex;
  @Input() checkUsage: boolean;

  confirm = false;

  confirmDelete() {
    if (this.checkUsage) {

    }
    else {
      this.deleteItem();
    }
  }

  private deleteItem() {
    this.inlineArrayItemSvc.deleteInlineArrayItemFromForm(this.fieldParameters, this.arrayIndex);
  }

}
